import {config as common_config} from '../../frontend/src/config';
import _log  from '../../frontend/src/log';
import jqextend from '../../frontend/src/jqextend';
import _engine from './engine';
import _fn from './fn';
import _event  from '../../frontend/src/event';

let config = Object.assign(common_config,
   {
      wm: WM,
      engine: 'gj'
   })

window.log = new _log({
   ajaxURL: config.ajaxURL,
   env: {
      wm: config.wm,
      engine: config.engine
   }
})

window.onerror = (msg, file, line, col, error) => {
   log.error({msg: msg}, error);
   return false;
}

jqextend(config.ajaxURL);

window.engine = new _engine(new _fn);

const requireResult = () => { // itt kell lennie a chunk generálás miatt
   const src = './result/result';
   require.ensure(['./result/result'], function () {
      let r = new require('./result/result').default;
      window.result = new r;
      window.result.setup(engine.settings.result);
      delete(engine.settings.result);
   });
}

new _event(config, requireResult)